// import { Injectable } from '@angular/core';
// import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { environment } from 'src/environments/environment';
// import { Url } from 'src/config';

// @Injectable({
//   providedIn: 'root'
// })
// export class DriveService {

//   // baseUrl:string = "http://localhost:8080";
//   driveDashboardUrl:string = environment.driveDashboardUrl;
//   baseUrl:string = environment.driveUrl;
//   userServiceUrl:string = environment.userServiceUrl;

//   constructor(private http:HttpClient) { }
//   addDrive(data) {
//     console.log('url: ', this.driveDashboardUrl + Url.addDrive);
//     return this.http.post(this.driveDashboardUrl + Url.addDrive, data, {
//       headers: new HttpHeaders().append('token', localStorage.getItem('token'))
//     });
//   }

//   getDriveListData() {
//     console.log('url: ', this.driveDashboardUrl + Url.addDrive);
//     return this.http.get(this.driveDashboardUrl + Url.addDrive, {
//       headers: new HttpHeaders().append('token', localStorage.getItem('token'))
//     });
//   }
//   getDriveList(){
//     console.log('url: ', this.driveDashboardUrl + Url.addDrive);
//     return this.http.get(this.driveDashboardUrl + "/drive/dashboard",{
//       headers: new HttpHeaders().append("token",localStorage.getItem("token"))
//     });
//   }

//   getDrivesByInstitutionId(institutionId:string){
//     return this.http.get(this.baseUrl + `/drive/details/${institutionId}`,{
//       headers: new HttpHeaders().append("token",localStorage.getItem("token"))
//     });
//   }

//   addEvent(data){
//     return this.http.post(this.baseUrl + "/drive/dashboard",data,{
//       headers: new HttpHeaders().append("token",localStorage.getItem("token"))
//     });
//   }

//   getDriveFunnelData(hiringDriveId:string){
//     return this.http.get(this.baseUrl + `/drive/funnelData/${hiringDriveId}`,{
//       headers: new HttpHeaders().append("token",localStorage.getItem("token"))
//     });
//   }

//   attendDrive(accesscode,shortname,userDTO){
//     return this.http.put(this.baseUrl + `/drive/attendance/${shortname}/${accesscode}`,userDTO);
//   }

//   registerUser(shortname,userDTO){
//     return this.http.put(this.baseUrl + `/drive/registration/${shortname}`,userDTO);
//   }

//   getWithoutTokens(options){
//     return this.http.get( this.userServiceUrl + options.purpose );
//   }


//   putWithoutTokens(options){
//     return this.http.put( this.baseUrl + options.purpose , options.body );
//   }
// }

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Url } from 'src/config';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DriveService {
token = 'eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiREVWIiwiZXhwIjoxNTU5NzMwMDM2LCJ1c2VySWQiOiIgIn0.JcTEsEQq-yaOQPGyKI_SBVTh7-jFVlKYyZkuBHgYC_0';
  //baseUrl:string = "http://191.168.0.161:8080";
//   driveDashboardUrl: string = environment.driveDashboardUrl;
//  baseUrl: string = environment.driveUrl;

  // baseUrl:string = "http://localhost:8080";
  driveDashboardUrl: string = environment.driveDashboardUrl;
  baseUrl: string = environment.driveUrl;
  userServiceUrl: string = environment.userServiceUrl;
  neededUrl: string;

  constructor(private http:HttpClient) { }

  private messageSource = new BehaviorSubject('');
  currentMessage = this.messageSource.asObservable();

  private updatedDataSource = new BehaviorSubject('');
  currentData = this.updatedDataSource.asObservable();
  changeMessage(message: string) {
    this.messageSource.next(message);
  }
  update(message: string) {
    this.updatedDataSource.next(message);
  }
  addDrive(data) {
    console.log('url: ', this.driveDashboardUrl + Url.addDrive);
    return this.http.post(this.driveDashboardUrl + Url.addDrive, data, {
      headers: new HttpHeaders().append('token', localStorage.getItem('token'))
    });
  }

  getDriveListData() {
    console.log('url: ', this.driveDashboardUrl + Url.addDrive);
    return this.http.get(this.driveDashboardUrl + Url.addDrive, {
       headers: new HttpHeaders().append('token', localStorage.getItem('token'))
    });
  }

  getDriveList() {
    console.log('url: ', this.driveDashboardUrl + Url.addDrive);
    return this.http.get(this.driveDashboardUrl + '/drive/dashboard', {
      headers: new HttpHeaders().append('token', localStorage.getItem('token'))
    });
  }

  getDrivesByInstitutionId(institutionId:string){
    return this.http.get(this.baseUrl + `/drive/details/${institutionId}`,{
      headers: new HttpHeaders().append("token", localStorage.getItem("token"))
     //headers: new HttpHeaders().append('token', this.token)
    });
  }

  addEvent(data) {
    return this.http.post(this.baseUrl + "/drive/dashboard",data,{
      headers: new HttpHeaders().append("token", localStorage.getItem("token"))
     //headers: new HttpHeaders().append('token', this.token)
    });
  }

  getDriveFunnelData(hiringDriveId: string) {
    return this.http.get(this.baseUrl + `/drive/funnelData/${hiringDriveId}`,{
      headers: new HttpHeaders().append("token", localStorage.getItem("token"))
     //headers: new HttpHeaders().append('token', this.token)
    });
  }

  attendDrive(accesscode, shortname, userDTO) {
    return this.http.put(this.baseUrl + `/drive/attendance/${shortname}/${accesscode}`, userDTO);
  }

  registerUser(shortname,userDTO) {
    return this.http.put(this.baseUrl + `/drive/registration/${shortname}`,userDTO);
  }

  uploadRecentDriveUser(hiringDriveId, registerOnlyUserDTOs): any {
    console.log('upload data in service ===>', registerOnlyUserDTOs);
    
   return this.http.post(this.baseUrl + '/drive/upload/selectedUsers/' + hiringDriveId,registerOnlyUserDTOs,{
     headers: new HttpHeaders().append('token', localStorage.getItem("token"))
  // headers: new HttpHeaders().append('token', this.token)
  })
}
  getWithoutTokens(options){
    return this.http.get( this.userServiceUrl + options.purpose );
  }

  putWithoutTokens(options){
    return this.http.put( this.baseUrl + options.purpose , options.body );
  }

  postWithoutTokens(options){
    return this.http.post(this.userServiceUrl + options.purpose , options.data);
  }

  postWithTokens(options){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      token: localStorage.getItem('token')
    });
this.neededUrl = this.userServiceUrl + options.purpose;
console.log("this.neededUrl: ", this.neededUrl);

   return this.http.post(this.neededUrl, options.data , {headers});
  }
  // getCompanies(){
  //   return this.http.get(this.driveDashboardUrl +`/adminservice/companies`,{
  //     headers:new HttpHeaders().append("token",localStorage.getItem("token"))
  //   });
  // }
  userKeyCorrection(data):any{
    return this.http.post(this.userServiceUrl+'/et/mcq/users/updateuserkey',data, {
     headers: new HttpHeaders().append('Authorization', localStorage.getItem("token"))
   })
     }
}

